import React from 'react';
import { Stack, Text } from '@moda/om';
import { RestAddressData } from '../../../hooks/useAddress';
import { ShippingAddressInfoBlock } from '../../ShippingAddress';

type Props = {
  address: RestAddressData;
};

export const AmazonShippingAddressPreview: React.FC<Props> = ({ address }) => (
  <Stack space={0}>
    <Stack space={1} direction="horizontal" alignItems="center">
      <img src="/amazon_payments.png" alt="Amazon Payments" />
      <Text treatment="eyebrow">Shipping Address</Text>
    </Stack>
    <ShippingAddressInfoBlock data={address.attributes} />
  </Stack>
);
